import type { ReactNode } from 'react';
import { Formik, type FormikValues } from 'formik';
import { Button, Offcanvas } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import SolarIcon from 'components/icons/SolarIcon';
import EToolTip from 'components/others/EToolTip';
import OffReportFilterForm from './OffReportFilterForm';
import { useReportFilter } from './model';

interface OffReportFilterProps<T> {
    values: T;
    defaults: T;
    onApply: (values: T) => void;
    active: boolean;
    disabled?: boolean;
    children: ReactNode;
}

const OffReportFilter = <T extends FormikValues,>({ values, defaults, onApply, active, disabled, children }: OffReportFilterProps<T>) => {
    const { t } = useTranslation(['Reports', 'common']);
    const filter = useReportFilter(onApply, defaults);
    const title = t('filtersTitle');
    return (
        <>
            <EToolTip title={title}>
                <span className="d-inline-block">
                    <Button size="sm" className="fs-14 px-2" variant={active ? 'danger' : 'primary'} disabled={disabled} aria-label={title} onClick={(event) => { event.currentTarget.blur(); filter.open(); }}>
                        <SolarIcon name="funnel" className="fs-14 p-0" />
                    </Button>
                </span>
            </EToolTip>
            <Offcanvas show={filter.show} onHide={filter.close} placement="end">
                <Offcanvas.Header closeButton className="border-bottom">
                    <Offcanvas.Title>{title}</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className="position-relative pb-0 d-flex flex-column px-0">
                    {filter.show && (
                        <Formik initialValues={values} onSubmit={filter.apply}>
                            <OffReportFilterForm onReset={filter.reset}>{children}</OffReportFilterForm>
                        </Formik>
                    )}
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default OffReportFilter;
